import { LinkProps } from 'react-router';
import { StyledLink } from './styles';

export const ButtonLink = (props: LinkProps) => <StyledLink {...props} />;
